module.exports = __webpack_public_path__ + "static/img/bg.ddff045a.png";